import classes from './PictureUpload.module.css';
import {
	Box,
	Button,
	Flex,
	Image,
	Text,
	Tooltip,
} from '@mantine/core';

import { FileButton } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { truncate } from 'lodash';
import useStore from '@store/index';

export const PictureUpload = (props: {
	onUpload: (formData: FormData | null) => void;
	src?: string;
}) => {
	const { t } = useTranslation();
	const [file, setFile] = useState<File | null>(null);
	const [preview, setPreview] = useState<string | null>(
		null
	);
	const resetRef = useRef<() => void>(null);
	const { getUser } = useStore();
	const user = getUser();

	const handleFileChange = (
		selectedFile: File | null
	) => {
		setFile(selectedFile);
		const formData = new FormData();
		formData.append('route', 'users');
		formData.append('document', user.id);
		if (selectedFile)
			formData.append('file', selectedFile);

		if (selectedFile) {
			const objectUrl = URL.createObjectURL(selectedFile);
			setPreview(objectUrl);
		} else {
			setPreview(null);
		}

		props.onUpload(formData);
	};

	const handleDelete = () => {
		setFile(null);
		setPreview(null);
		resetRef.current?.();
		props.onUpload(null);
	};

	useEffect(() => {
		if (props.src) {
			setPreview(props.src);
		}
	}, [props.src]);

	return (
		<Box className={classes.rowPicture}>
			<Box className={classes.previewPicture}>
				<Image
					src={preview}
					className={classes.avatar}
					fallbackSrc={
						'https://t3.ftcdn.net/jpg/09/61/19/22/360_F_961192237_jZyPwdtITDhzhe5IEV3nQ1D8SqQWK3ww.jpg'
					}
				/>
				<Flex
					direction="column"
					align="flex-start"
					justify="center"
				>
					<Tooltip
						label={file?.name}
						disabled={
							!!(
								file &&
								file.name &&
								file?.name?.length <= 30
							) || !file
						}
					>
						<Box>
							<Text className={classes.textTitle}>
								{file && file.name
									? truncate(file.name, {
											length: 30,
										})
									: t('global.logo')}
							</Text>
						</Box>
					</Tooltip>
					<Text className={classes.textDescription}>
						{t('global.infoUploadPicture')}
					</Text>
				</Flex>
			</Box>
			<Box className={classes.actionsPicture}>
				<FileButton
					resetRef={resetRef}
					onChange={handleFileChange}
					accept="image/png,image/jpeg"
				>
					{(props) => (
						<Button
							size="xs"
							variant="outline"
							{...props}
						>
							{t('global.uploadNewPicture')}
						</Button>
					)}
				</FileButton>

				<Button
					onClick={handleDelete}
					size="xs"
					variant="filled"
					className={classes.customDeleteButton}
				>
					{t('global.delete')}
				</Button>
			</Box>
		</Box>
	);
};
